import { useParams } from "react-router-dom"

export default function withUrlParams(WrappedComponent) {
  const WithUrlParamsWrapper = function (props) {
    const params = useParams()
    return <WrappedComponent params={params} {...props} />
  }
  WithUrlParamsWrapper.displayName = `withUrlParams(${WrappedComponent.displayName || WrappedComponent.name})`
  return WithUrlParamsWrapper
}
